import { FRAME } from '@ezugi/constants/device';

import isIframe from '../predicates/isIframe';
import isPopup from '../predicates/isPopup';

export const getFrame = () => (isPopup() && FRAME.POPUP) || (isIframe() && FRAME.IFRAME) || FRAME.FULL;
